import urlParser from 'js-video-url-parser';

const VIMEO_REGEX = /^https?:\/\/(www\.)?(vimeo\.com\/(video\/)?[0-9]+|player\.vimeo\.com\/video\/[0-9]+)(\?.*)?$/;
const YOUTUBE_REGEX = /^https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(?:[?&].*)?$/;

export const isVimeoUrl = (url: string) => {
  return VIMEO_REGEX.test(url);
};

export const isYoutubeUrl = (url: string) => {
  return YOUTUBE_REGEX.test(url);
};

export const isVideoUrl = (url: string) => {
  return isVimeoUrl(url) || isYoutubeUrl(url);
};

export const extractVimeoVideoId = (videoUrl: string): string | null => {
  const vimeoMatch = videoUrl.match(/(?:player\.)?vimeo\.com\/(?:video\/)?([0-9]+)/);

  if (vimeoMatch) {
    return vimeoMatch[1];
  }

  return null;
};

export const extractYoutubeVideoId = (url: string): string | null => {
  const youtubeMatch = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})(?:[?&]|$)/);

  if (youtubeMatch) {
    return youtubeMatch[1];
  }

  const youtubeShortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})(?:[?&]|$)/);
  if (youtubeShortMatch) {
    return youtubeShortMatch[1];
  }

  return null;
};

export const getVideoDataFromUrl = (url: string) => {
  const videoInfo = urlParser.parse(url);

  if (!videoInfo) {
    return;
  }

  const embedUrl = urlParser.create({
    videoInfo,
    format: 'embed',
  });
  const thumbnailUrl =
    videoInfo.provider === 'youtube'
      ? urlParser.create({
          videoInfo,
          params: {
            imageQuality: 'maxresdefault',
          },
          format: 'longImage',
        })
      : `https://vumbnail.com/${videoInfo.id}.jpg`;

  return {
    embedUrl,
    thumbnailUrl,
  };
};
